interface RestrictionErrorInfo {
  title: string;
  message: string;
  numCode: number;
}

export const RESTRICTION_ERRORS: Record<string, RestrictionErrorInfo> = {
  GRADE: {
    title: 'Wrong grade',
    message: 'This person is not in a required grade',
    numCode: 1,
  },
  NO_PARTY: {
    title: 'No party group',
    message: ' is in a no party group with another student already registered',
    numCode: 2, // This error code must match the error code for NO_PARTY in IHallPassErrorType
  },
  NO_REGISTRATION_LIST: {
    title: 'No registration list',
    message: 'This person is on the "FlexTime no registration list"',
    numCode: 3, // This error code must match the error code for NO_PASS in IHallPassErrorType
  },
  GROUP: {
    title: 'Not group member',
    message: 'This person is not in a required group',
    numCode: 4,
  },
  NO_ACCESS: {
    title: 'No access list',
    message: 'This person is currently on the no access list',
    numCode: 5,
  },
  NOT_MEMBER: {
    title: 'Not a member',
    message: 'This person does not meet the membership requirement',
    numCode: 6,
  },
  ROLE: {
    title: 'Wrong role',
    message: 'This person does not meet the role requirements',
    numCode: 7,
  },
  STICKER: {
    title: 'No sticker',
    message: 'This person does not meet the sticker requirements',
    numCode: 8,
  },
  NOT_REGISTERED: {
    title: 'Not registered',
    message: 'This person is not registered',
    numCode: 9,
  },
  NOT_CHECKED_IN: {
    title: 'Not checked in',
    message: 'This person does meet prior check in requirements',
    numCode: 10,
  },
  ALREADY_CHECKED_IN: {
    title: 'Already checked in',
    message: 'This person has already been checked in today',
    numCode: 11,
  },
  DOESNT_EXIST: {
    title: 'Not found',
    message: 'Does not exist',
    numCode: 12,
  },
  PERSON_DOESNT_EXIST: {
    title: 'Not found',
    message: 'This person does not exist',
    numCode: 13,
  },
  NO_RULES: {
    title: 'No rules',
    message: 'Does not have any restrictions',
    numCode: 14,
  },
  UNKNOWN: {
    title: 'Unknown error',
    message: 'An unexpected error has occured',
    numCode: 15,
  },
  NO_SPACE: {
    title: 'No space available',
    message: 'The activity is full',
    numCode: 16,
  },
  NO_TICKET: {
    title: 'Need a ticket',
    message: 'Need an event ticket to check in',
    numCode: 17,
  },
  INVALID_CODE: {
    title: 'Invalid code',
    message: 'The code entered is invalid',
    numCode: 18,
  },
  SYSTEM_ERROR: {
    title: 'System error',
    message: 'Unable to check in at the moment, please try again later',
    numCode: 19,
  },
  NOT_AVAILABLE_IN_KIOSK: {
    title: 'Not available in kiosk',
    message: 'This check in is not enabled for kiosk use',
    numCode: 20,
  },
  USER_LIST: {
    title: 'Not on list',
    message: 'This person is not on the required list',
    numCode: 21,
  },
  MULTIPLE_HOMEROOMS: {
    title: 'Multiple homerooms',
    message: 'Multiple homerooms attached',
    numCode: 22,
  },
  NO_HOMEROOM: {
    title: 'No homeroom',
    message: 'No homeroom attached',
    numCode: 23,
  },
  NO_HOMEROOM_ACTIVITY: {
    title: 'No homeroom activity',
    message: 'No homeroom teacher activity',
    numCode: 24,
  },
  GENERIC_HOMEROOM_ASSIGN: {
    title: 'Unable to assign homeroom activity',
    message: 'There was a problem assigning homeroom activity',
    numCode: 25,
  },
  PAST_DEADLINE_ERROR: {
    title: 'Registration past deadline',
    message: 'Registrations are now closed. Contact your teacher to be registered',
    numCode: 26,
  },
  CHECK_IN_CLOSED: {
    title: 'Check in closed',
    message: 'Check in is no longer available for this activity.',
    numCode: 27,
  },
  CHECK_IN_UNAVAILABLE: {
    title: 'Check in unavailable',
    message: "Check in opens 10 minutes before the activity's start time.",
    numCode: 28,
  },
} as const;

export const ACTIVITY_RESTRICTION_ERRORS_TITLES = {
  GRADE: {
    header: `This person doesn't match the activity restriction`,
  },
  GROUP: {
    header: `This person doesn't match the activity restriction`,
  },
  NO_ACCESS: {
    header: `This person doesn't match the activity restriction`,
  },
  NOT_MEMBER: {
    header: `This person doesn't match the activity restriction`,
  },
  ROLE: {
    header: `This person doesn't match the activity restriction`,
  },
  STICKER: {
    header: `This person doesn't match the activity restriction`,
  },
  NOT_REGISTERED: {
    header: `This person doesn't match the activity restriction`,
  },
  NOT_CHECKED_IN: {
    header: `This person doesn't match the activity restriction`,
  },
  ALREADY_CHECKED_IN: {
    header: `This person doesn't match the activity restriction`,
  },
  DOESNT_EXIST: {
    header: `This person doesn't match the activity restriction`,
  },
  PERSON_DOESNT_EXIST: {
    header: `This person doesn't match the activity restriction`,
  },
  NO_RULES: {
    header: `This person doesn't match the activity restriction`,
  },
  UNKNOWN: {
    header: `This person doesn't match the activity restriction`,
  },
  NO_SPACE: {
    header: `This activity is at maximum capacity`,
  },
  NO_PARTY: {
    header: `No party group`,
  },
  PAST_DEADLINE_ERROR: {
    header: `Registration past deadline`,
  },
  NO_REGISTRATION_LIST: {
    header: 'No registration list',
  },
  CHECK_IN_CLOSED: {
    header: `Check in closed`,
  },
  CHECK_IN_UNAVAILABLE: {
    header: `Check in unavailable`,
  },
} as const;
